/** Formato de fecha para UI: AAAA/MM/DD */
export const UI_DATE_FORMAT = 'yyyy/MM/dd';

/** Formato de fecha y hora para UI: AAAA/MM/DD HH:mm */
export const UI_DATE_TIME_FORMAT = 'yyyy/MM/dd HH:mm';
